import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@app/material.module';
import { ResetPasswordComponent } from './reset-password.component';
import { SharedModule } from '@app/@shared';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ResetPasswordRoutingModule } from './reset-password-routing.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    SharedModule,
    MaterialModule,
    ResetPasswordRoutingModule,
  ],
  declarations: [ResetPasswordComponent],
})
export class ResetPasswordModule {}
